import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ErrorScreen } from './components/errors/error';
import { LessonScreen } from './components/screens/lesson-screen';
import { getUrlParams } from './utils/get-url-params';

export default function App() {
  const { environment } = getUrlParams();

  if (!environment) {
    return (
      <ErrorScreen message="There is an error with your request, environment is a required parameter" />
    );
  }

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <SafeAreaProvider>
        <LessonScreen />
      </SafeAreaProvider>
    </QueryClientProvider>
  );
}
